import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SessionStore {
  sessionId: string | null
  teamId: string | null
  teamName: string | null
  isFacilitator: boolean
  setTeam: (sessionId: string, teamId: string, teamName: string) => void
  setFacilitator: (sessionId: string) => void
  clear: () => void
}

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      sessionId: null,
      teamId: null,
      teamName: null,
      isFacilitator: false,
      setTeam: (sessionId, teamId, teamName) =>
        set({ sessionId, teamId, teamName, isFacilitator: false }),
      setFacilitator: (sessionId) =>
        set({ sessionId, teamId: null, teamName: null, isFacilitator: true }),
      clear: () => set({
        sessionId: null, teamId: null, teamName: null, isFacilitator: false,
      }),
    }),
    { name: 'ai-trans-sim-session' },
  ),
)
